"use client";

import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { useState } from "react";

interface BookingCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  isSelected?: boolean;
  onClick?: () => void;
}

export function BookingCard({
  icon: Icon,
  title,
  description,
  isSelected = false,
  onClick,
}: BookingCardProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Card
      className={cn(
        "w-full p-4 sm:p-6 border rounded-md cursor-pointer transition-all duration-300 h-full min-h-[190px] flex flex-col",
        "hover:shadow-lg active:scale-[0.98]",
        isSelected ? "border-primary ring-2 ring-primary ring-opacity-50" : "",
        isHovered ? "translate-y-[-4px]" : "",
      )}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <CardHeader className="text-center space-y-2 p-0 flex-1 flex flex-col items-center justify-center">
        <div className="mx-auto">
          <Icon size={28} className={cn("text-primary sm:h-8 sm:w-8")} />
        </div>
        <CardTitle className="mt-3 sm:mt-4 text-base sm:text-lg min-h-[1.5rem] line-clamp-1">
          {title}
        </CardTitle>
        <CardDescription className="text-sm min-h-[2.5rem] line-clamp-2">
          {description}
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
